import { AxiosRequestConfig } from 'axios';

export interface CaptchaPuzzleProps {
  showModal: boolean
  newRequestConfig?: AxiosRequestConfig
  resolve?: Function
  reject?: Function
}

export interface CaptchaPuzzleStateProps {
  captchaPuzzle: CaptchaPuzzleProps
  setCaptchaPuzzle: Function
}

export const defaultCaptchaPuzzle = {
  captchaPuzzle: {
    showModal: false
  },
  setCaptchaPuzzle: () => {},
}

export const testCaptchaPuzzleData = {
  captchaPuzzle: {
    showModal: false
  },
  setCaptchaPuzzle: () => {},
}

export const initialCaptchaPuzzleState: CaptchaPuzzleStateProps = {
  ...defaultCaptchaPuzzle,
}

export const testCaptchaPuzzleInitialState: CaptchaPuzzleStateProps = {
  ...testCaptchaPuzzleData,
}
